import "./OptionGridHeaderComponent.scss";
import {IComponentOptions} from "angular";

export const OptionGridHeader = "tfOptionGridHeader";

export function optionGridHeader(): IComponentOptions {
    return {
        templateUrl: "app/services/option-chain/popup/grid-header/OptionGridHeaderComponent.html",
        controllerAs: "ctrl",
        controller: OptionGridHeaderComponentController
    };
}

export class OptionGridHeaderComponentController {
}
